import axios from "axios";
import { Parser } from "html-to-react";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { BiDetail, BiGridAlt, BiLayout } from "react-icons/bi";
import { FaWindowClose, FaCube } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import crm from "../../assets/images/crm.jpg";
import ecommerce from "../../assets/images/ecommerce.jpg";
import ecommerce2 from "../../assets/images/ecommerce2.jpg";
import food from "../../assets/images/food.jpg";
import list from "../../assets/images/list.jpg";
import lms from "../../assets/images/lms.jpg";
import realestate from "../../assets/images/realestate.jpg";
import touroperator from "../../assets/images/touroperator.jpg";
import Spacer from "../../components/Utils/Spacer";
import { Context } from "../../context";
import projectsData from "../../data/projects.json";
import DemoCard2 from "../Demo/DemoCard2";
import InfoModal from "./InfoModal";
import LatestSiteCard from "./LatestSiteCard";
import classes from "./Project.module.css";
// const url = "https://www.aroundweb.it/davidebalice.dev/data/projects.json";

const Project = () => {
  const [overlay, setOverlay] = useState(false);
  const [login, setLogin] = useState(false);
  const [viewInfo, setViewInfo] = useState(false);
  const [info, setInfo] = useState("");
  // Use local data instead of fetching
  const [data, setData] = useState(projectsData);
  const [backgroundColor, setBackgroundColor] = useState("#f1f1f1");
  const [selectedCard, setSelectedCard] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [viewDemo, setViewDemo] = useState(false);
  const [error, setError] = useState(false);
  const { debug, lang } = useContext(Context);

  const openPopupCard = (e, info, card) => {
    setSelectedCard(card);
    setOverlay(true);
  };

  const handleCloseCard = () => {
    setSelectedCard(null);
    setOverlay(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === "demo" && password === "admin_demo") {
      setViewDemo(true);
      setLogin(false);
    } else {
      setError(true);
    }
  };

  const closeInfo = () => {
    setInfo("");
    setViewInfo(false);
  };

  // const getData = async () => {
  //   const response = await axios.get(url);
  //   const compareByOrder = (a, b) => a.order - b.order;
  //   const sortedData = [...response.data].sort(compareByOrder);
  //   setData(sortedData);
  // };

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <>
      {viewInfo && info && <InfoModal onClose={closeInfo} info={info} />}

      {login && (
        <div className={`${classes.requestAccessLoginBg}`}>
          <div className={`${classes.requestAccessLogin}`}>
            <div
              onClick={() => {
                setLogin(false);
              }}
              className={`${classes.FaWindowCloseContainer}`}
            >
              <FaWindowClose className={`${classes.FaWindowClose}`} />
            </div>
            <Spacer height={1} />
            {lang === "en" ? (
              <b>Access demo of some projects</b>
            ) : (
              <b>Accedi alle demo di alcuni progetti</b>
            )}
            <Spacer height={28} />
            <div className={`${classes.demoForm}`}>
              <label>Username</label>
              <input
                type="text"
                value={username}
                className={`form-control ${classes.inputForm}`}
                onChange={(e) => setUsername(e.target.value)}
              />
              <Spacer height={20} />
              <label>Password</label>
              <input
                type="password"
                value={password}
                className={`form-control ${classes.inputForm}`}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Spacer height={20} />
              <input
                type="submit"
                value=" Login "
                onClick={handleSubmit}
                className={`${classes.buttonForm}`}
              />
            </div>
            <Spacer height={10} />
            {error && (
              <div className={`${classes.incorrectData}`}>Incorrect data</div>
            )}
            <Spacer height={1} />
          </div>
        </div>
      )}

      <div fluid className={classes.bg9}>
        <header className="text-center py-3">
          <h2
            className="text-5 fw-400 px-3 mt-5"
            style={{ lineHeight: "35px" }}
          >
            {lang === "en" && (
              <>
                These projects have been developed in recent years, include
                entire cms,
                <br /> graphic editors, booking software for tourism, ecommerce,
                medical records management software and more.
                <br />
                There are just some of the projects developed.
              </>
            )}
            {lang === "it" && (
              <>
                Progetti sviluppati negli ultimi anni, includono interi cms,
                editor grafici, <br />
                software di prenotazione per il turismo, ecommerce, software per
                gestione cartelle cliniche.
                <br />
              </>
            )}
          </h2>
        </header>
        <Container
          fluid
          className="text-center pb-5 pt-5 col-xl-8"
          style={{ maxWidth: "1300px" }}
        >
          <div className={classes.mainTitle}>
            {lang === "en" ? "Projects" : "Progetti"}
          </div>
          <div className="row portfolio">
            {data
              .filter((item) => item.id === 12 || item.id === 11 || item.id === 1 || item.id === 2 || item.id === 10 || item.id === 13)
              .sort((a, b) => {
                const order = [12, 11, 1, 2, 10, 13];
                return order.indexOf(a.id) - order.indexOf(b.id);
              })
              .map((item) => {
                return (
                  <div className="col-12 col-md-6 col-lg-4 px-4 mb-4 d-flex align-items-stretch" key={item.title}>
                    <div
                      className="portfolio-box mb-3 w-100 d-flex flex-column"
                      style={{ textAlign: "left" }}
                    >
                      <div
                        className={`${classes.projectCard} mt-3 h-100`}
                        onMouseEnter={() => {
                          setSelectedCard(item.title);
                        }}
                        onMouseLeave={() => setBackgroundColor("#fff")}
                        style={{
                          backgroundColor: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                        }}
                      >
                        {/* BASH HEADER */}
                        <div className={classes.titleBarLight}>
                          <div className={classes.dots}>
                            <div className={`${classes.dot} ${classes.dotRed}`}></div>
                            <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                            <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                          </div>
                          <div className={classes.tabLight}>
                            {item.slug}.js
                          </div>
                        </div>

                        {/* Image Full Width - No Padding */}
                        <div className={`${classes.projectImgContainer}`}>
                          <div
                            className={classes.projectImg}
                            style={{
                              background: `url("assets/images/${item.photo}.jpg")`,
                              backgroundSize: "cover",
                              backgroundPosition: "center"
                            }}
                          ></div>
                        </div>

                        {/* Text Content - Padded */}
                        <div className={`${classes.projectTextContainer} d-flex flex-column flex-grow-1`}>
                          <div className={classes.titleContainer}>
                            <div className={classes.projectUrl}>{item.url.split("?")[0]}</div>
                          </div>
                          <div className={`${classes.projectColumn} d-flex flex-column flex-grow-1`}>
                            <p>
                              {lang === "en"
                                ? Parser().parse(item.short_desc)
                                : Parser().parse(item.short_desc_it)}
                            </p>

                            {/* Custom Buttons for WebHub (3 buttons: Servizio, Piattaforme, Template) */}
                            {item.id === 12 && (
                              <div className={classes.actionButtonsContainer}>
                                <a
                                  href="https://www.webhub.it"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <BiDetail style={{ fontSize: 14 }} />
                                  {lang === "en" ? "Service" : "Servizio"}
                                </a>
                                <a
                                  href="https://www.webhub.it/piattaforme-web"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <BiGridAlt style={{ fontSize: 14 }} />
                                  {lang === "en" ? "Platforms" : "Piattaforme"}
                                </a>
                                <a
                                  href="https://www.webhub.it/template-siti-web"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <BiLayout style={{ fontSize: 14 }} />
                                  {lang === "en" ? "Templates" : "Template"}
                                </a>
                              </div>
                            )}

                            {/* Custom Buttons for RoomMaker (id 10) */}
                            {item.id === 10 && (
                              <div className={classes.actionButtonsContainer}>
                                <a
                                  href="https://www.webhub.it/piattaforme/editor-3d-ambienti-room-maker/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <BiDetail style={{ fontSize: 14 }} />
                                  {lang === "en" ? "Service" : "Servizio"}
                                </a>
                                <a
                                  href={item.url2}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <FaCube style={{ fontSize: 14 }} />
                                  Demo
                                </a>
                              </div>
                            )}

                            {/* Custom Buttons for SitiWeb 3D (id 13) (2 buttons: Servizio, Demo) */}
                            {item.id === 13 && (
                              <div className={classes.actionButtonsContainer}>
                                <a
                                  href={item.url.startsWith("http") ? item.url : `https://${item.url}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <BiDetail style={{ fontSize: 14 }} />
                                  {lang === "en" ? "Service" : "Servizio"}
                                </a>
                                <a
                                  href={item.url2}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <FaCube style={{ fontSize: 14 }} />
                                  Demo
                                </a>
                              </div>
                            )}

                            {/* Default button for other projects */}
                            {item.id !== 12 && item.id !== 10 && item.id !== 13 && item.id !== 4 && (
                              <div className={classes.actionButtonsContainer}>
                                <a
                                  href={
                                    item.url.startsWith("http")
                                      ? item.url
                                      : `https://${item.url}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classes.actionBtn}
                                >
                                  <BiDetail style={{ fontSize: 16 }} />
                                  {lang === "en" ? "details" : "dettaglio"}
                                </a>
                              </div>
                            )}

                            {item.id === 4 && (
                              <div className="text-right mt-auto">
                                <NavLink
                                  to={`/demo-request`}
                                  className="nav-link smooth-scroll"
                                >
                                  <button
                                    type="button"
                                    className={`${classes.detailsButton} btn btn-info mt-2`}
                                  >
                                    <BiDetail className={classes.detailsIcon} />
                                  </button>
                                </NavLink>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          {/*
          <div className={classes.latestSitesSection}>
            <div className={classes.latestSitesTitle}>
              {lang === "en" ? "Latest developed sites" : "Ultimi siti sviluppati"}
            </div>
            <div className="row">
              <LatestSiteCard
                image="assets/images/dvaglobal.jpg"
                domain="www.dva.global"
                url="https://www.dva.global"
              />
              <LatestSiteCard
                image="assets/images/assetvalue.jpg"
                domain="www.assetvalue.it"
                url="https://www.assetvalue.it"
              />
              <LatestSiteCard
                image="assets/images/logisupport.jpg"
                domain="www.logisupport.it"
                url="https://www.logisupport.it"
              />
            </div>
          </div>
          */}

          <hr />

          <div className={`${classes.requestAccessText}`}>
            {lang === "en" && (
              <>
                <b>Access demo</b>
                <br />
                <b>of some real projects</b>
                <br /> <br />
                Demos are <b>generic</b> and{" "}
                <b>not contains real customer/user data</b>,
                <br />
                and <b>not contains client know-how</b>.
                <br /> <br />
              </>
            )}
            {lang === "it" && (
              <>
                <b>Accesso demo</b>
                <br />
                <b>di alcuni progetti reali</b>
                <br /> <br />
                Le demo sono <b>generiche</b> e
                <b>non contengono dati reali di clienti/utenti</b>,
                <br />e <b>non contengono know-how del cliente</b>.
                <br /> <br />
              </>
            )}
          </div>

          <div className={`${classes.demoCard2Container}`}>
            <DemoCard2
              id="1"
              title_en="Learning management system"
              description_en="App for managing and selling online courses"
              title_it="Learning management system"
              description_it="App per la gestione e vendita di corsi online"
              img={lms}
              url="https://laravel-lms.davidebalice.dev"
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
              viewInfo={true}
              lock={false}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
            />
            <DemoCard2
              id="2"
              title_en="Ecommerce"
              description_en="Ecommerce site - multi vendor"
              title_it="Ecommerce"
              description_it="Sito web ecommerce - multi venditore"
              img={ecommerce2}
              url="https://laravel-ecommerce.davidebalice.dev"
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
              viewInfo={true}
              lock={false}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
            />
            <DemoCard2
              id="8"
              title_en="Food order ecommerce"
              description_en="Food order web site."
              title_it="Ecommerce food"
              description_it="Sito web per acquisto cibo online."
              img={food}
              url="https://laravel-food-ecommerce.davidebalice.dev"
              viewDemo={viewDemo}
              lock={false}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
              viewInfo={true}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
            />
            <DemoCard2
              id="9"
              title_en="Real estate"
              description_en="Real estate listing platform."
              title_it="Immobiliare"
              description_it="Piattaforma per pubblicazione annunci immobliari."
              img={realestate}
              url="https://laravel-realestate.davidebalice.dev"
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              lock={false}
              openPopupCard={openPopupCard}
              viewInfo={true}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
            />
            {/*
             <DemoCard2
              id="10"
              title_en="News portal"
              description_en="Portale per pubblicazione news."
              title_it="Portale news"
              description_it="Portal for news publication."
              img={news}
              url="asfasd"
              viewDemo={viewDemo}
              setLogin={setLogin}
              lock={false}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            */}

            <div className={`${classes.requestAccessText}`}>
              {lang === "en" && (
                <>
                  <b>Request access</b>
                  <br />
                  <b>to demos of some real projects</b>
                  <br /> <br />
                  Demos are <b>generic</b> and{" "}
                  <b>not contains real customer/user data</b>,
                  <br />
                  and <b>not contains client know-how</b>.
                  <br /> <br />
                </>
              )}
              {lang === "it" && (
                <>
                  <b>Richiedi accesso</b>
                  <br />
                  <b>alle demo di alcuni progetti reali</b>
                  <br /> <br />
                  Le demo sono <b>generiche</b> e{" "}
                  <b>non contengono dati reali di clienti/utenti</b>,
                  <br />e <b>non contengono know-how del cliente</b>.
                  <br /> <br />
                </>
              )}
            </div>

            {/*
              <DemoCard2
              id="2"
              title_en="Shop management"
              description_en="Crm for managing a point of sale, products, orders, suppliers."
              title_it="Gestione negozio"
              description_it="Crm per la gestione di un punto vendita, prodotti, ordini, fornitori."
              img={shop}
              url="asfasd"
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            */}

            <DemoCard2
              id="4"
              title_en="Editor + Ecommerce"
              description_en="Sitishop platform. Web site Editor and Ecommerce."
              title_it="Editor + Ecommerce"
              description_it="Piattaforma Sitishop. Editor visuale ed Ecommerce."
              img={ecommerce}
              lock={true}
              url="asfasd"
              viewInfo={true}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            <DemoCard2
              id="5"
              title_en="Editor + Tour Operator website"
              description_en="Sitishop platform. Web site Editor and Tour Operator website."
              title_it="Editor + Tour Operator website"
              description_it="Piattaforma Sitishop. Editor visuale ed Tour Operator website."
              img={touroperator}
              url="asfasd"
              viewDemo={viewDemo}
              viewInfo={true}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              setLogin={setLogin}
              lock={true}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            <DemoCard2
              id="6"
              title_en="Wedding online list"
              description_en="Software for management wedding online list and birth online list"
              title_it="Liste nozze online"
              description_it="Software gestione liste nozze e liste nascita online."
              img={list}
              url="asfasd"
              lock={true}
              viewInfo={true}
              setInfo={setInfo}
              setViewInfo={setViewInfo}
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            <DemoCard2
              id="3"
              title_en="Crm leads and hr"
              description_en="Crm with Leads, Estimates, Customers and Human Resources management."
              title_it="Crm lead e risorse umane"
              description_it="Crm con gestione Leads, Preventivi, Clienti e Risorse umane."
              img={crm}
              url="asfasd"
              viewDemo={viewDemo}
              setLogin={setLogin}
              lock={true}
              selectedCard={selectedCard}
              openPopupCard={openPopupCard}
            />
            {/*
             <DemoCard2
              id="7"
              title_en="Clinic records"
              description_en="Software for management clinic records."
              title_it="Cartelle cliniche"
              description_it="Software per gestione cartelle cliniche."
              img={clinic}
              url="asfasd"
              viewDemo={viewDemo}
              setLogin={setLogin}
              selectedCard={selectedCard}
              lock={true}
              openPopupCard={openPopupCard}
            />
            */}
          </div>
        </Container >
        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
        <script src="js/theme.js"></script>
      </div >
    </>
  );
};

export default Project;
